import { CheckbookArrowRightIcon } from './CheckbookArrowRightIcon';

/**
 * author: Jeff Anders
 * id 1EE03F8D-8B51-464B-84DE-6079644BA583
 * name checkbook-arrow-right
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbook-arrow-right.svg
 * tags
 * - Banking 
 */
export const ChequebookArrowRightIcon = CheckbookArrowRightIcon;
export default ChequebookArrowRightIcon